import { useCallback } from "react";

import { useAction } from "@/hooks/shared";
import { getCurrentUserHandler } from "@/services";
import type { AuthUserType } from "@/types";
import { saveUserHandler } from "@/utils";

export const useCurrentUser = () => {
    const action = useAction<[], AuthUserType>(getCurrentUserHandler);

    const runHandler = useCallback(
        async () => {
            const user = await action.onRun();

            saveUserHandler(user);

            return user;
        },
        [action],
    );

    return {
        ...action,
        onRun: runHandler,
    };
};
